import { Link } from 'react-router-dom';
import { heroMedia } from '../utils/mediaConfig.js';

const Industrial = () => (
  <>
  <section className="relative h-[820px] tablet:px-6 tablet:h-auto tablet:min-h-[560px]">
    <video autoPlay muted loop playsInline preload="metadata" poster={heroMedia.industrial.poster} aria-hidden="true" className="absolute inset-0 w-full h-full object-cover">
      <source src={heroMedia.industrial.video} type="video/mp4" />
    </video>
    <div className="absolute inset-0 [background:linear-gradient(90deg,_rgba(7,9,53,0.97)_0%,_rgba(7,9,53,0.8)_50%,_rgba(7,9,53,0.2)_100%)]">
    </div>
    <div className="relative pt-[240px] px-[120px] pb-0 max-w-[940px] flex flex-col gap-7 tablet:pt-[124px] tablet:px-6 tablet:pb-16">
      <p className="m-0 text-[16px] text-mx-accent-light tracking-[0.04em] font-display">
        Industrial & process equipment
      </p>
      <h1 className="m-0 font-medium text-[76px] leading-[1.04] tracking-[-0.02em] font-display tablet:text-[44px] tablet:leading-[1.08]">
        Machined, cast and molded parts for equipment makers
      </h1>
      <p className="m-0 text-[20px] leading-[1.6] text-mx-copy max-w-[700px]">
        For OEMs building heaters, pumps, compressors, valves and machinery. We quote your existing parts at landed cost and take on new designs from prototype to volume.
      </p>
      <div className="flex gap-4 mt-2 phone:flex-wrap">
        <Link to="/contact" className="mx-button">
          Send us your drawing
        </Link>
        <Link to="#ie-products" className="mx-button-outline">
          What we supply
        </Link>
      </div>
    </div>
  </section>
  <section id="ie-products" className="pt-[140px] px-[120px] pb-0 flex flex-col gap-12 tablet:px-6">
    <h2 className="m-0 font-medium text-[52px] leading-[1.1] max-w-[760px] font-display tablet:text-[32px]">
      Components we supply
    </h2>
    <div className="grid [grid-template-columns:repeat(3,_minmax(0,_1fr))] gap-6 tablet:[grid-template-columns:1fr]">
      <div className="bg-mx-card border border-mx-border rounded-[20px] overflow-hidden flex flex-col tablet:min-w-0">
        <img src="/media/images/turned-part.jpg" alt="CNC-turned stainless steel part" loading="lazy" className="h-[200px] border-0 block w-full object-cover" />
        <div className="p-7 flex flex-col gap-2.5">
          <h3 className="m-0 font-semibold text-[22px] font-display">
            Machined components
          </h3>
          <p className="m-0 text-[16px] leading-[1.6] text-mx-muted">
            Shafts, flanges, housings, manifolds and fittings in steel, stainless and aluminum.
          </p>
        </div>
      </div>
      <div className="bg-mx-card border border-mx-border rounded-[20px] overflow-hidden flex flex-col tablet:min-w-0">
        <img src="/media/images/die-cast-brackets.jpg" alt="Die-cast aluminum brackets" loading="lazy" className="h-[200px] border-0 block w-full object-cover" />
        <div className="p-7 flex flex-col gap-2.5">
          <h3 className="m-0 font-semibold text-[22px] font-display">
            Castings
          </h3>
          <p className="m-0 text-[16px] leading-[1.6] text-mx-muted">
            Pump and valve bodies, covers and housings, cast and machined to finish.
          </p>
        </div>
      </div>
      <div className="bg-mx-card border border-mx-border rounded-[20px] overflow-hidden flex flex-col tablet:min-w-0">
        <img src="/media/images/laser-cutting.jpg" alt="Fiber laser cutting sheet metal" loading="lazy" className="h-[200px] border-0 block w-full object-cover" />
        <div className="p-7 flex flex-col gap-2.5">
          <h3 className="m-0 font-semibold text-[22px] font-display">
            Stamped and fabricated parts
          </h3>
          <p className="m-0 text-[16px] leading-[1.6] text-mx-muted">
            Brackets, panels, guards, frames and welded enclosures.
          </p>
        </div>
      </div>
      <div className="bg-mx-card border border-mx-border rounded-[20px] overflow-hidden flex flex-col tablet:min-w-0">
        <img src="/media/images/injection-mold.jpg" alt="Open injection mold with molded housings" loading="lazy" className="h-[200px] border-0 block w-full object-cover" />
        <div className="p-7 flex flex-col gap-2.5">
          <h3 className="m-0 font-semibold text-[22px] font-display">
            Injection-molded parts
          </h3>
          <p className="m-0 text-[16px] leading-[1.6] text-mx-muted">
            Covers, knobs, housings and insulators in engineering plastics.
          </p>
        </div>
      </div>
      <div className="bg-mx-card border border-mx-border rounded-[20px] overflow-hidden flex flex-col tablet:min-w-0">
        <img src="/media/images/bearings.jpg" alt="Industrial ball and roller bearings" loading="lazy" className="h-[200px] border-0 block w-full object-cover" />
        <div className="p-7 flex flex-col gap-2.5">
          <h3 className="m-0 font-semibold text-[22px] font-display">
            Bearings and hardware
          </h3>
          <p className="m-0 text-[16px] leading-[1.6] text-mx-muted">
            Bearings, bushings, seals and fasteners sourced to your specification.
          </p>
        </div>
      </div>
      <div className="bg-mx-card border border-mx-border rounded-[20px] overflow-hidden flex flex-col tablet:min-w-0">
        <img src="/media/images/assembly-bench.jpg" alt="Precision sub-assembly on a workbench" loading="lazy" className="h-[200px] border-0 block w-full object-cover" />
        <div className="p-7 flex flex-col gap-2.5">
          <h3 className="m-0 font-semibold text-[22px] font-display">
            Sub-assemblies and kits
          </h3>
          <p className="m-0 text-[16px] leading-[1.6] text-mx-muted">
            Assembled, tested and kitted so they go straight to your line.
          </p>
        </div>
      </div>
    </div>
  </section>
  <section className="mt-40 p-[120px] bg-mx-panel border-t border-mx-border border-b border-mx-border grid [grid-template-columns:repeat(2,_minmax(0,_1fr))] gap-20 tablet:px-6 tablet:mx-4 tablet:[grid-template-columns:1fr]">
    <div className="flex flex-col gap-6 tablet:min-w-0">
      <h2 className="m-0 font-medium text-[48px] leading-[1.1] font-display tablet:text-[32px]">
        Lower cost on the parts you already buy
      </h2>
      <p className="m-0 text-[18px] leading-[1.6] text-mx-copy">
        Send the drawing and your current price. We come back with a landed-cost quote, and first articles you can qualify before switching.
      </p>
    </div>
    <ul className="m-0 p-0 list-none flex flex-col tablet:min-w-0">
      <li className="py-6 px-0 border-t border-mx-border flex flex-col gap-1.5">
        <strong className="text-[20px] font-semibold font-display">
          First articles before volume
        </strong>
        <span className="text-[16px] leading-[1.6] text-mx-muted">
          Inspection reports on request, so you approve before you commit.
        </span>
      </li>
      <li className="py-6 px-0 border-t border-mx-border flex flex-col gap-1.5">
        <strong className="text-[20px] font-semibold font-display">
          Blanket orders with scheduled releases
        </strong>
        <span className="text-[16px] leading-[1.6] text-mx-muted">
          Annual pricing with deliveries matched to your production plan.
        </span>
      </li>
      <li className="py-6 px-0 border-t border-mx-border border-b border-mx-border flex flex-col gap-1.5">
        <strong className="text-[20px] font-semibold font-display">
          A second source for risky parts
        </strong>
        <span className="text-[16px] leading-[1.6] text-mx-muted">
          Protect your line from single-supplier delays and price jumps.
        </span>
      </li>
    </ul>
  </section>
  <section className="mt-[140px] mx-[120px] mb-0 py-[72px] px-20 bg-mx-accent rounded-[28px] flex justify-between items-center gap-12 tablet:px-6 tablet:mx-4 tablet:flex-wrap">
    <div className="flex flex-col gap-3 text-mx-ink">
      <h2 className="m-0 font-semibold text-[44px] leading-[1.1] font-display tablet:text-[32px]">
        See what your parts should cost
      </h2>
      <p className="m-0 text-[18px] leading-[1.6] max-w-[620px]">
        Send a drawing and annual volume. We reply within 24 hours.
      </p>
    </div>
    <Link to="/contact" className="inline-flex items-center min-h-14 px-8 py-0 rounded-[999px] bg-mx-ink text-white font-semibold text-[16px] whitespace-nowrap font-display">
      Request a quote
    </Link>
  </section>
  </>
);
export default Industrial;
